import React, { createContext, useState, useEffect } from 'react';
import api from '../services/api';
import PropTypes from 'prop-types';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // setIsLoading(true) is default, no need to set again here
      api.get('/auth/me')
        .then(res => {
          setUser(res.data);
          setError(null);
        })
        .catch(err => {
          console.error('Auth check error:', err);
          localStorage.removeItem('token');
          setUser(null);
          setError('Authentication failed. Please try logging in again.');
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false); // No token, so not loading user
    }
  }, []);

  const login = async (email, password) => {
    setIsLoading(true);
    try {
      setError(null);
      const res = await api.post('/auth/login', { 
        email, 
        password
      });
      const { token, user } = res.data;
      localStorage.setItem('token', token);
      setUser(user);
      return user;
    } catch (err) {
      console.error('Login error:', err);
      setError(err.response?.data?.error || 'Login failed. Please check your credentials.');
      throw err;
    }
    finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    setIsLoading(true); // Technically, we are changing auth state
    localStorage.removeItem('token');
    setUser(null);
    setError(null);
    setIsLoading(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
